import { atom } from 'recoil';

export const triggerRefetchEvaluations = atom<boolean>({
  key: 'SIDEBAR_EVALUTION_TRIGGER_REFETCH',
  default: false,
});
